import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Paper, Typography, TextField, Slider, Button, Select, MenuItem, FormControl, InputLabel } from '@mui/material';
import { filterCandidateAction } from './actions';
import { useSelector,useDispatch } from 'react-redux';
import HeightBox from '../../components/HeightBox';

const SearchFilters = ({ onSearch, filterCandidate,filters,handleFilterChange }) => {

  const dispatch = useDispatch();
  const [loading,setLoading]=useState(false)

  const handleSearch = async () => {
    // Perform data fetching or any other actions using the filters state
    
    setLoading(true)
    await dispatch(filterCandidateAction(filters));
    setLoading(false)
  };

  

  return (
    <Paper style={{ padding: '1rem', position: 'sticky', top: '10px' }}>
      <Typography variant="h6">Search Filters</Typography>
      <TextField
        label="Name"
        name="name"
        size="small"
        value={filters.name}
        onChange={handleFilterChange}
        fullWidth
        margin="normal"
      />
      <TextField
        label="Applied Position"
        name="jobTitle"
        size="small"
        value={filters.jobTitle}
        onChange={handleFilterChange}
        fullWidth
        margin="normal"
      />

      <TextField
        label="Location"
        name="location"
        size="small"
        value={filters.location}
        onChange={handleFilterChange}
        fullWidth
        margin="normal"
      />

      <TextField
        label="Experience Country"
        name="experienceCountry"
        size="small"
        value={filters.experienceCountry}
        onChange={handleFilterChange}
        fullWidth
        margin="normal"
      />
      <FormControl fullWidth margin="normal">
  <InputLabel htmlFor="gender">Gcc Experience check</InputLabel>
      <Select
        label="Gcc Experience"
        name="gccExperienced"
        size="small"
        value={filters.gccExperienced}
        onChange={handleFilterChange}
        fullWidth
        margin="normal"

      >
        <MenuItem value="">Select GCC Experience</MenuItem>
        <MenuItem value="yes">Yes</MenuItem>
        <MenuItem value="no">Don't Consider</MenuItem>
      </Select>
    </FormControl>

   <FormControl fullWidth margin="normal">
  <InputLabel htmlFor="gender">Select Gender</InputLabel>
  <Select
    labelId="gender-label"
    id="gender"
    name="gender"
    size="small"
    value={filters.gender}
    onChange={handleFilterChange}
    fullWidth
    displayEmpty
  >
    <MenuItem value="">Select Gender</MenuItem>
    <MenuItem value="male">Male</MenuItem>
    <MenuItem value="female">Female</MenuItem>
  </Select>
</FormControl>
<HeightBox height={10} />
<FormControl fullWidth margin="normal">
  <InputLabel htmlFor="availability">Availability</InputLabel>
  <Select
    labelId="availability-label"
    id="availability"
    name="availability"
    size="small"
    value={filters.availability}
    onChange={handleFilterChange}
    fullWidth
    displayEmpty
  >
    <MenuItem value="">Select Availability</MenuItem>
    <MenuItem value="Immediately">Immediately</MenuItem>
    <MenuItem value="Within a week">Within a week</MenuItem>
    <MenuItem value="Within two weeks">Within two weeks</MenuItem>
    <MenuItem value="Within three weeks">Within three weeks</MenuItem>
    <MenuItem value="After one month notice period">After one month notice period</MenuItem>
  </Select>
</FormControl>

      <TextField
        label="Minimum Experience"
        name="experience"
        size="small"
        value={filters.experience}
        onChange={handleFilterChange}
        fullWidth
        margin="normal"
      />
      {/* <TextField
        label="Skills"
        name="skills"
        size="small"
        value={filters.skills}
        onChange={handleFilterChange}
        fullWidth
        margin="normal"
      /> */}
      {/* <Slider
        name="salaryRange"
        label='Salary Range'
        value={filters.salaryRange}
        onChange={handleFilterChange}
        valueLabelDisplay="auto"
        min={0}
        max={100000}
        marks={[
          { value: 0, label: '0' },
          { value: 100000, label: '100000' },
        ]}
        aria-labelledby="salary-range-slider"
      />
       <Slider
        name="ageRange"
        label='Age Range'
        value={filters.ageRange}
        onChange={handleFilterChange}
        valueLabelDisplay="auto"
        min={0}
        max={100}
        marks={[
          { value: 0, label: '0' },
          { value: 100, label: '100' },
        ]}
        aria-labelledby="age-range-slider"
      /> */}
      <HeightBox height={20} />
      <Button disabled={loading} variant="contained" color="primary" fullWidth onClick={handleSearch}>
        {loading ? (
          <>
          Loading ....
          </>
        ):(
          <>
          Reset
          </>
        )
        }
      </Button>
    </Paper>
  );
};

export default SearchFilters;